var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"d-flex"},[_c('div',[_c('button',{on:{"click":_vm.dashboard}},[_vm._v("Profile")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }